import { __read, __spread } from "tslib";
import { breakpointList } from '../../../foundation';
var bpListL2S = __spread(breakpointList).reverse();
export var getMatchedBreakpoint = function (width, breakpointMap) {
    // no match when width is less than min width of XS
    return bpListL2S.find(function (bp) { return width >= breakpointMap[bp]; }) || null;
};
